import React from 'react'
import AriaViewer from './ariaViewer'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import MobileDetect from 'aria-viewer/utils/mobileDetect'

const AriaViewerDesktop = React.lazy(() => import('aria-viewer/tour/containers/AriaViewerDesktop'))
import desktopAnalytics from './analytics/desktopAnalytics'
import desktopInteractions from './interactions/desktopInteractions'

const AriaViewerMobile = React.lazy(() => import('aria-viewer/tour/containers/AriaViewerMobile'))
import mobileAnalytics from './analytics/mobileAnalytics'
import mobileInteractions from './interactions/mobileInteractions'

const AriaViewerEmbed = React.lazy(() => import('aria-viewer/tour/containers/AriaViewerEmbed'))

import SocketProxy from 'aria-viewer/analytics/utils/socket/socketProxy'
import { isInIframe } from 'aria-viewer/utils/iframe'

require('aria-viewer/utils/polyfill')

const isPhone = MobileDetect.phone() !== null
const isResponsiveEmbed = QueryParamUtils.useResponsiveUI()

// Adds socketConfig option which gets injected in analyticsMiddleware.js
const withSocket = analytics =>
    analytics.map(a => {
        a.socketConfig = {
            socket: SocketProxy, // the type of socket we're injecting is a socket proxy for emitting messages to parent iframe window
        }
        return a
    })

const getAnalytics = ({ isMobile, includeSocket }) => {
    const analytics = isMobile ? [mobileAnalytics, mobileInteractions] : [desktopAnalytics, desktopInteractions]

    return includeSocket ? withSocket(analytics) : analytics
}

const analytics = getAnalytics({
    isMobile: isPhone,
    includeSocket: isInIframe(),
})

const component = isResponsiveEmbed ? AriaViewerEmbed : isPhone ? AriaViewerMobile : AriaViewerDesktop
const appPath = isResponsiveEmbed
    ? 'aria-viewer/tour/containers/AriaViewerEmbed'
    : isPhone
    ? 'aria-viewer/tour/containers/AriaViewerMobile'
    : 'aria-viewer/tour/containers/AriaViewerDesktop'

const render = AriaViewer(component, analytics)

if (module.hot) {
    module.hot.accept(appPath, () => {
        const NextApp = require(appPath).default

        render(NextApp)
    })
}
